var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#83ACEB",
    strokeWidth: 2,
    d: "M3 6.5A2.5 2.5 0 0 1 5.5 4h13.786c.2 0 .299 0 .38.028a.5.5 0 0 1 .306.307c.028.08.028.18.028.38 0 1.196 0 1.795-.168 2.276a3 3 0 0 1-1.841 1.84C17.51 9 16.91 9 15.714 9H15M3 6.5A2.5 2.5 0 0 0 5.5 9H19c.943 0 1.414 0 1.707.293S21 10.057 21 11v2M3 6.5V17c0 1.886 0 2.828.586 3.414S5.114 21 7 21h12c.943 0 1.414 0 1.707-.293S21 19.943 21 19v-2m0 0h-4c-.943 0-1.414 0-1.707-.293S15 15.943 15 15s0-1.414.293-1.707S16.057 13 17 13h4m0 4v-4"
  })));
};
export default SvgWallet;